import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import {  Router } from '@angular/router';

import { ApplicationStateService } from 'src/app/services/application-state.service';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';
import { TransactionService } from 'src/app/services/transaction/transaction.service';

import {
  Transaction,
  TransactionStatus,
} from 'src/app/models/transaction.interface';
import { TransactionStatusTypeId } from 'src/app/models/transaction-enums.model';

import { BaseInvoiceComponent } from '../base.invoice.component';
import { Invoice } from 'src/app/models/invoice.interface';
import { forkJoin, Subject, takeUntil, tap } from 'rxjs';
import { LoadingService } from '../../../core/services/loading/loading.service';

@Component({
  selector: 'app-success',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InvoiceSuccessComponent implements OnInit, OnDestroy {

  public transactionStatusItems: TransactionStatus | undefined;
  public transactionStatusTypeId = TransactionStatusTypeId;
  transaction!: Transaction;
  invoice!: Invoice;
  private unsubscribe$ = new Subject<any>();
  showInvoice = false;
  showSuccess = true;

  constructor(
    @Inject('INVOICE_TRACKING_KEY') private invoiceTrackingKey: string,
    private applicationState: ApplicationStateService,
    private router: Router,   
    private invoiceService: InvoiceService,
    private transactionService: TransactionService,
    private loadingService: LoadingService
  ) {}


  ngOnInit(): void {
    this.initialize();
  }

  handleDownload(status: boolean): void {
    this.showInvoice = status;
    this.showSuccess = !status;
  }

  handleBackClick(): void {
    this.loadingService.attach();
    this.applicationState.nextStep('');
    this.router.navigate(['/invoice', this.invoiceTrackingKey]).
      finally(() => this.loadingService.deattach());
  }

  handlePayBalanceClick(): void {
    this.applicationState.nextStep('payment');    
    this.router.navigateByUrl(`/invoice/${this.invoiceTrackingKey}/payment`);
  }

  private initialize() {
   const invoice$ = this.invoiceService
      .getInvoice(this.invoiceService.login.invoiceId).pipe(
        tap(invoice => {
          this.invoiceService.setInvoiceData(invoice);
        }));

    const transaction$ =   this.transactionService
         .getTransaction(this.invoiceService.login.transactionId).pipe(
         tap(transaction =>{
          this.transactionService.setTransaction(transaction);
         })
         );

    forkJoin({
      invoice: invoice$,
      transaction: transaction$
    }).pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(({invoice,transaction}) => {    
      
      this.transaction = {...transaction};
      this.invoice = {...invoice};

      this.transactionStatusItems =
        BaseInvoiceComponent.getTransactionStatusItems(
          transaction,
          invoice
        );

      this.transactionService.setTransactionStatusItems(
        this.transactionStatusItems
      );
    });  
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

}
